import { createContext } from "react";
export const GlobalDataContext= createContext({})